<template>
    <div class="row mb-2">
        <div class="col-4">
            <template v-if="label">
                <label :for="id" class="control-label">{{label}}</label>
            </template>
            <template v-else>
                <slot name="label" :id="id" />
            </template>
        </div>
        <div class="col-8">
            <input-group v-if="hasIcon" :icon="icon">
                <slot name="input" :id="id">

                </slot>
            </input-group>

            <slot v-else name="input" :id="id">
                
            </slot>
            
            <slot name="errors" />
        </div>
    </div>    
</template>

<script>
import {guid} from '@core/Util/guid';

import inputGroup from '@core/Components/Inputs/InputGroup.vue';

export default {
    name: 'settings-property',
    components: {
        inputGroup
    },
    props: {
        label: {
            type: String,
            required: false
        },
        
        icon: {
            type: String,
            default: ''
        }
    },
    computed: {
        hasIcon() {
            return this.icon != '';
        }
    },
    data(){
        return {
            id: `FIELD_${guid()}`
        }
    }
};
</script>

<style lang="scss" scoped>

</style>